import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';

import { clearVerdicts, getVerdictScale } from 'actions/verdicts';

import VerdictFeedbackForm from 'containers/Verdict/Form/Partials/VerdictFeedbackForm';
import VerdictLevelForm from 'containers/Verdict/Form/Partials/VerdictLevelForm';
import { getSchoolSettings } from 'actions/schools';

import { Icon, Button, TooltipMenu, Checkbox } from '@haldor/ui';
import { getSchoolId } from 'lib/msal';
import User from '_class/User';
import { Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

class MultipleVerdictForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			level: '0',
			feedback: '',
			loading: true,
			visibleToGuardiansAndStudents: true,
			user: new User(this.props.currentUser)
		};
	}

	componentDidMount = async () => {
		let currentSchoolId = await getSchoolId();

		if (this.props.scale == null) {
			await this.props.getVerdictScale();
		}

		if (this.state.user != null && this.state.user.isTeacher() && this.props.schoolSettings == null || this.props.schoolSettings?.schoolId != currentSchoolId) {
			await this.props.getSchoolSettings();
		}

		/* set visibleToGuardiansAndStudents from school settings */
		if (this.props.schoolSettings != null) {
			this.setState({ visibleToGuardiansAndStudents: this.props.schoolSettings.defaultVerdictVisibility });
		}

		this.setState({ loading: false });
	};

	removeStudent = (student) => {
		if (this.props.onRemoveStudent != null) {
			this.props.onRemoveStudent(student);
		}
	}

	abort = (event) => {
		event.preventDefault();
		this.props.onAbort();
	}

	toggleVisibleToGuardiansAndStudents = () => {
		this.setState({
			visibleToGuardiansAndStudents: !this.state.visibleToGuardiansAndStudents
		});
	}

	submit = (values) => {
		return new Promise(resolve => {
			let data = [];

			this.props.students.forEach(student => {
				data.push({
					scaleLevelId: this.state.level,
					feedback: this.state.feedback,
					scaleId: this.props.scale.id,
					status: 'VERDICT_DRAFT',
					userId: student.id,
					visibleToGuardiansAndStudents: this.state.visibleToGuardiansAndStudents
				});
			});

			if (this.props.onSubmit != null) {
				this.props.onSubmit(data).then(() => {
					resolve(1);
				});
			} else {
				resolve(1);
			}
		});
	}

	render() {
		const { submitting, handleSubmit } = this.props;
		const { feedback, level, loading } = this.state;

		if (loading) {
			return <div></div>
		}

		let visibilitySettingEnabled = this.props.schoolSettings?.enableVerdictVisibilitySetting;
		let permissionClass = visibilitySettingEnabled ? "permission-active" : "permission-inactive";

		return (
			<div>
				{submitting ?
					<div className="is_sending" style={{ height: '100%', top: 0 }}>
						<p><span className="loading-spinner" /></p>
					</div>
					: null}

				<div className="form-container">
					<form onSubmit={handleSubmit(this.submit)} className="form form-component">
						<div className="form-row">
							<div className="verdict verdict-users-list">
								{this.props.translate('students')}

								{this.props.students.map(student => {
									const dropdownTrigger = (<div className="dropdown--trigger">
										<Icon name="Bullets" />
									</div>);

									return <div className="verdict-user" key={student.id}>
										<div className="name">
											{student.firstName} {student.lastName}
										</div>

										<TooltipMenu trigger={dropdownTrigger}>
											<TooltipMenu.Item onClick={() => this.removeStudent(student)}>
												{this.props.translate('Delete')}
											</TooltipMenu.Item>
										</TooltipMenu>
									</div>
								})}
							</div>
						</div>

						<div className="form-row" style={{ marginTop: '1.55rem' }}>
							{this.props.translate('verdicts')}

							{this.props.scale != null ?
								<VerdictLevelForm
									levels={this.props.scale.levels}
									value={level}
									onChange={level => this.setState({ level })}
									key={this.props.scale.id}
								/>
								: null}
						</div>

						<div className="form-row">
							<VerdictFeedbackForm
								value={this.state.feedback}
								onChange={feedback => this.setState({ feedback })}
							/>
						</div>

						<div className="form-row">
							<Box sx={{ mt: '1.05rem', ml: 0.7 }}>
								<Checkbox
									value={this.state.visibleToGuardiansAndStudents}
									onChange={(checked) => visibilitySettingEnabled && this.setState({ visibleToGuardiansAndStudents: checked })}
									disabled={!visibilitySettingEnabled}
									label={this.props.translate('Show the evaluation for students and guardians')}
								/>
								{!visibilitySettingEnabled && (
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1, ml: 0.5, fontSize: '0.875rem', color: '#666' }}>
										<InfoOutlinedIcon sx={{ fontSize: '16px' }} />
										<span>{this.props.translate('The option to change the setting is disabled by your school. For support, contact your school administrator.')}</span>
									</Box>
								)}
							</Box>
						</div>

						<div className="form-row submit" style={{ marginTop: '1.25rem', marginBottom: '1.25rem' }}>
							<Button disabled={level == 0 || level == null || submitting}>
								{this.props.translate('save-draft')}
							</Button>

							<div className="align-right">
								<Button onClick={this.abort} type="secondary">
									{this.props.translate('Cancel')}
								</Button>
							</div>

							<div className="clearfix"></div>
						</div>
					</form>
				</div>
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		scale: state.Verdicts.scale,
		currentUser: state.user.currentUser,
		schoolSettings: state.School.schoolSettings,
	};
}

export default connect(mapStateToProps, {
	getVerdictScale,
	clearVerdicts,
	getSchoolSettings
}, null, {
	pure: false,
})(reduxForm({
	form: 'MultipleVerdictForm',
	destroyOnUnmount: true,
})(MultipleVerdictForm));